import 'css-chunksrc/client/pages/projectPage/exportsPage/styles.scss';export default {
  "exportsPage": "_exportsPage_1j6ee_1",
  "main": "_main_1j6ee_8",
  "col": "_col_1j6ee_18",
  "subTitle": "_subTitle_1j6ee_25",
  "description": "_description_1j6ee_30",
  "list": "_list_1j6ee_36"
};